export default __webpack_public_path__ + "images/withoutSecure_aacfc9.svg";